import React from 'react';
import { commonStyles } from 'utils/designSystem';

export const TableContainer = ({ children }) => (
  <div style={commonStyles.tableContainer}>
    <div style={commonStyles.tableWrapper}>
      {children}
    </div>
  </div>
);

export const Table = ({ children, style = {} }) => (
  <table style={{ ...commonStyles.table, ...style }}>
    {children}
  </table>
);

export const TableHeader = ({ children, style = {} }) => (
  <th style={{ ...commonStyles.th, ...style }}>{children}</th>
);

export const TableCell = ({ children, onClick, style = {} }) => (
  <td 
    style={{ ...commonStyles.td, ...style }}
    onClick={onClick}
    onMouseEnter={(e) => e.target.parentElement.style.backgroundColor = '#f8fafc'}
    onMouseLeave={(e) => e.target.parentElement.style.backgroundColor = 'transparent'}
  >
    {children}
  </td>
);
